import { ChevronRight } from "lucide-react";
import { useSite } from "@/hooks/use-site";
import { localizeUrl } from "@/lib/site";
type BreadcrumbItem = {
  label: string;
  href?: string;
};

export function PageBreadcrumb({ items }: { items: BreadcrumbItem[] }) {
  const { site, messages, href } = useSite();
  const home = localizeUrl("/", site.locale, href);

  return (
    <div className="border-b border-border/60 bg-background/60">
      <nav
        aria-label={messages.breadcrumbLabel}
        className="mx-auto flex w-full max-w-7xl items-center gap-1.5 px-6 py-3 text-xs text-muted-foreground"
      >
        <a href={home} className="shrink-0 hover:text-foreground">
          {messages.tv6UltraBreadcrumbHome}
        </a>
        {items.map((item, index) => (
          <span key={`${item.label}-${index}`} className={`flex items-center gap-1.5 ${item.href ? "shrink-0" : "min-w-0 flex-1"}`}>
            <ChevronRight className="h-3 w-3 shrink-0" />
            {item.href ? (
              <a href={item.href} className="hover:text-foreground">
                {item.label}
              </a>
            ) : (
              <span className="truncate text-foreground">{item.label}</span>
            )}
          </span>
        ))}
      </nav>
    </div>
  );
}
